export default function buildPostShopData({
    apiEndpoint,
    apiTools
}) {
    return async function postShopData(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/pre-approved`
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}